import type { FastifyInstance } from 'fastify'
import { weatherController } from './weather.controller.js'
import { requireAuth } from '../../core/auth/auth.middleware.js'

export async function weatherRoutes(fastify: FastifyInstance) {
  // Public endpoint - get weather for location
  fastify.get('/weather', {
    schema: {
      querystring: {
        type: 'object',
        required: ['lat', 'lng'],
        properties: {
          lat: { type: 'number', minimum: -90, maximum: 90 },
          lng: { type: 'number', minimum: -180, maximum: 180 },
          name: { type: 'string' }
        }
      }
    },
    handler: weatherController.getWeather.bind(weatherController)
  })

  // Protected endpoint - get route weather analysis
  fastify.get('/weather/route/:planId', {
    preHandler: [requireAuth],
    handler: weatherController.getRouteWeather.bind(weatherController)
  })

  // Protected endpoint - compare weather for dates
  fastify.post('/weather/compare', {
    preHandler: [requireAuth],
    schema: {
      body: {
        type: 'object',
        required: ['lat', 'lng', 'dates'],
        properties: {
          lat: { type: 'number' },
          lng: { type: 'number' },
          dates: {
            type: 'array',
            items: { type: 'string', format: 'date-time' },
            minItems: 1,
            maxItems: 7
          }
        }
      }
    },
    handler: weatherController.compareWeather.bind(weatherController)
  })
}
